import React, { useEffect, useState } from 'react';

// Utils
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';
import * as S from './styles';
import { Step, StepLabel, StepLabelProps, Stepper } from '@mui/material';
import { SpinnerLoading } from '../styles';
import { useDispatch } from 'react-redux';
import { signalRClearReceiveUpdatesByKey } from '@/main/store/signalR';
import { SendUpdatesSignalRTypeEnum } from '@/main/services/enum/SendUpdatesSignalRTypeEnum';
import { toast } from 'react-toastify';
import { RoutesConstants } from '@/main/routes/routesConstants';
import { useNavigate } from 'react-router-dom';
import { getRefreshForceUrl } from '@/main/services/utilsQueryParams';
import { SignalRPrequoteResponse } from '@/main/models/common/signalRReceiveUpdatesResponse';
import { PrequoteProgressEnum } from '@/main/services/enum/PrequoteProgressEnum';
interface HubItemPrequoteProps {
  data: SignalRPrequoteResponse[];
  customProps?: {}
}

const HubItemPrequote = ({ data, customProps }: HubItemPrequoteProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formatteedData = isNullUndefined(data) ? [] : data;
  const [activeStep, setActiveStep] = useState(0);

  const hasErrorPrequote = formatteedData.some(
    item => item.progressStatus === PrequoteProgressEnum.Error
  );
  const hasFinishedPrequote = formatteedData.some(
    item => item.progressStatus === PrequoteProgressEnum.Finished
  );
  const stepsWithLabel = [
    {
      key: PrequoteProgressEnum.CreatingNewQuote,
      label: getTranslateByKey("requoteProcurement.creatingNewQuote"),
    },
    {
      key: PrequoteProgressEnum.SelectingSuppliers,
      label: getTranslateByKey("requoteProcurement.selectingSuppliers"),
    },
    {
      key: PrequoteProgressEnum.Finished,
      label: getTranslateByKey("requoteProcurement.finished"),
    }
  ];

  function getCustomIconProp(currentIndex: number): StepLabelProps {
    if (!hasFinishedPrequote && !hasErrorPrequote && currentIndex === activeStep) return { icon: <SpinnerLoading customSize='20px' /> }
    return {};
  }

  useEffect(() => {
    const lastItemPrequoteSignalR = formatteedData[formatteedData.length - 1];
    if (isNullUndefined(lastItemPrequoteSignalR)) {
      setActiveStep(0);
      return;

    };
    if (hasErrorPrequote) {
      const findedStepError = formatteedData.find((item) => item.progressStatus === PrequoteProgressEnum.Error);
      const messageError = isNullUndefined(findedStepError) ? getTranslateByKey('information.somethingWrong', true) : findedStepError.message;
      toast.error(messageError, { autoClose: 10000 });
      return
    }
    const findedIndexCurrent = stepsWithLabel.findIndex(
      item => item.key === lastItemPrequoteSignalR.progressStatus
    );

    setActiveStep(findedIndexCurrent === -1 ? 0 : (findedIndexCurrent + 1));
    if (hasFinishedPrequote) {
      if (!isNullUndefined(lastItemPrequoteSignalR.claimNumber)) {
        const filters = getRefreshForceUrl({
          quoteFilterVehicle: lastItemPrequoteSignalR.claimNumber,
        })
        const routeRedirect = `${RoutesConstants.orderSearchOrder}${filters}`;
        navigate(routeRedirect);

      }
      dispatch(signalRClearReceiveUpdatesByKey(SendUpdatesSignalRTypeEnum.PreQuote))
      return
    }
  }, [JSON.stringify(formatteedData)])


  return (
    <S.Container>
      <Stepper activeStep={activeStep} orientation="vertical">
        {stepsWithLabel.map((item, index) => (
          <Step key={`stepper-${index}`}>
            <StepLabel
              error={hasErrorPrequote && index === activeStep}
              {...getCustomIconProp(index)}
            >
              {item.label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </S.Container>
  );
};

export default HubItemPrequote;
